export default function setServerContext(data) {
    return {
        type: 'SET-SERVER-CONTEXT',
        data
    };
}
